<ion-header translucent [ngClass]="isLoginPage ? 'display-none' : 'recovery-header'" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button color="primary" defaultHref="/"></ion-back-button>
    </ion-buttons>
    <ion-title color="primary">Login</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-no-padding" [ngClass]="isLoginPage ? 'login-background' : ''">
  <div height-100 [ngClass]="{'bg-linear': !isLoginPage}">
    <ion-img [ngClass]="isLoginPage ? 'login-logo' : 'recovery-logo'" [src]="logo" (click)="goToLogin()"></ion-img>
    <ion-content [ngClass]="{'bg-linear': isLoginPage, 'bg-default': !isLoginPage}">
      <ion-router-outlet></ion-router-outlet>
    </ion-content>
  </div>
</ion-content>

<app-button-language></app-button-language>